const URLS = {
  COMPANIES: "/v3/teams/users/companies",
};

export default URLS;
